import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { ContentShareComponent } from 'src/app/pages/campaigns/content-share/content-share.component';

export const contentShare: Route = {
  path: 'content-share',
  title: 'nav.campaigns.contentShare',
  data: {
    icon: SbIcons.checkList,
    breadcrumb: 'nav.campaigns.contentShare',
    id: RoutingID.contentShare,
  },
  children: [
    {
      path: '',
      component: ContentShareComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
